import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import {withStyles} from "@material-ui/core";
import Card from "../../common/Card";
import {convertISODateTimeToBRLocale} from "../../common/Util";
import {renderMilisecondsToTimeDuration} from "../../utils/datetimehelp";

const styles = theme => ({
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(1) * 2,
    }
});


class RoitreadCycles extends Component {
    constructor(props) {
        super();
        const { cycles } = props;

    }


    render() {
        const { cycles } = this.props;
        console.log('Roitreadcycles', cycles);
        if (cycles == null || cycles.length == 0) {
            return (<React.Fragment/>);
        }
        return (
                <Card style={{ backgroundColor: 'yellow', display:"flex",flexGrow:12, flexBasis:'100%',  justifyContent:'space-between', marginTop: '10px' }}>


                        {cycles.map( (cic,ix) =>{
                            if (cic.teveExtrusao) {

                                return (
                                    <table border="0">
                                        <tr>
                                            <th>Abertura Mandril</th>
                                            <th>Coluna</th>
                                            <th>Ciclo</th>
                                            <th>Extrusão</th>
                                            <th>tempo Anterior</th>
                                            <th>Inicio Extrusao</th>
                                            <th>Ciclo</th>
                                            <th>Largura</th>
                                            <th>Consumo</th>
                                            <th>Tempo Extrusao</th>
                                            <th>Final Extrusao</th>
                                            <th>Tempo Roletagem</th>
                                            <th>Tempo Outros</th>
                                            <th>Fechar Mandril</th>
                                        </tr>
                                        <tr key={ix}>
                                            <td>{convertISODateTimeToBRLocale(cic.DTInicioCiclo)}</td>
                                            <td>{cic.posicao}</td>
                                            <td>{cic.ciclo}</td>
                                            <td>Sim</td>
                                            <td>{renderMilisecondsToTimeDuration(cic.tempoAnteriorExtrusaoSec * 1000)}</td>
                                            <td>{convertISODateTimeToBRLocale(cic.extrusoraDTInicioCiclo)}</td>
                                            <td>{cic.extrusoraCiclo}</td>
                                            <td>{cic.extrusoraLargura}</td>
                                            <td>{cic.extrusoraConsumo}</td>
                                            <td>{renderMilisecondsToTimeDuration(cic.tempoExtrusaoSec * 1000)}</td>
                                            <td>{convertISODateTimeToBRLocale(cic.extrusoraDTFimCiclo)}</td>
                                            <td>{renderMilisecondsToTimeDuration(cic.tempoRoletagemSec * 1000)}</td>
                                            <td>{renderMilisecondsToTimeDuration(cic.tempoOutrosSec * 1000)}</td>
                                            <td>{convertISODateTimeToBRLocale(cic.DTFimCiclo)}</td>
                                        </tr>

                                    </table>)
                            } else {
                                return (
                                    <table border="0">
                                        <tr>
                                            <th>Abertura Mandril</th>
                                            <th>Coluna</th>
                                            <th>Ciclo</th>
                                            <th>Extrusão</th>
                                            <th>Tempo Aplic. Banda</th>

                                            <th>Tempo Roletagem</th>
                                            <th>Tempo Outros</th>
                                            <th>Fechar Mandril</th>
                                        </tr>
                                        <tr key={ix}>
                                            <td>{convertISODateTimeToBRLocale(cic.DTInicioCiclo)}</td>
                                            <td>{cic.posicao}</td>
                                            <td>{cic.ciclo}</td>
                                            <td>Nao</td>
                                            <td>{renderMilisecondsToTimeDuration(cic.tempoAplicacaoBandaSec * 1000)}</td>
                                            <td>{renderMilisecondsToTimeDuration(cic.tempoRoletagemSec * 1000)}</td>
                                            <td>{renderMilisecondsToTimeDuration(cic.tempoOutrosSec * 1000)}</td>
                                            <td>{convertISODateTimeToBRLocale(cic.DTFimCiclo)}</td>
                                        </tr>

                                    </table>)
                            }

                        })}


                </Card>
        );
    }
}
export default (withStyles(styles, {withTheme: true}))(RoitreadCycles);
